import * as React from "react";

function IconLongitude(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M12 2a10 10 0 1010 10A10.03 10.03 0 0012 2M9.4 19.6a8.05 8.05 0 010-15.2A16.45 16.45 0 007.5 12a16.45 16.45 0 001.9 7.6m2.6.4a13.81 13.81 0 01-2.5-8A13.81 13.81 0 0112 4a13.81 13.81 0 012.5 8 13.81 13.81 0 01-2.5 8m2.6-.4a16.15 16.15 0 000-15.2A8.03 8.03 0 0120 12a7.9 7.9 0 01-5.4 7.6z" />
    </svg>
  );
}

export default IconLongitude;
